const NAME = "REQUESTED_DOCUMENTS_PAGE";

export default NAME;
